import { render, staticRenderFns } from "./togetherAiUpgradeNew.vue?vue&type=template&id=21acd45f&scoped=true"
import script from "./togetherAiUpgradeNew.vue?vue&type=script&lang=js"
export * from "./togetherAiUpgradeNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21acd45f",
  null
  
)

export default component.exports